import { useState } from "react";
import { Card, Typography, Segmented } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import styles from "./AmazonCharts.module.css";

const { Title, Text } = Typography;

// Mock data for the chart
const chartData = [
  { name: "Jan", value: 100 },
  { name: "Feb", value: 120 },
  { name: "Mar", value: 130 },
  { name: "Apr", value: 150 },
  { name: "May", value: 170 },
  { name: "Jun", value: 190 },
  { name: "Jul", value: 220 },
  { name: "Aug", value: 250 },
  { name: "Sep", value: 280 },
  { name: "Oct", value: 300 },
  { name: "Nov", value: 320 },
  { name: "Dec", value: 350 },
];

const timeRanges = [
  { label: "12 months", value: "12m" },
  { label: "30 days", value: "30d" },
  { label: "7 days", value: "7d" },
  { label: "24 hours", value: "24h" },
];

export const AmazonCharts = () => {
  const [activeRange, setActiveRange] = useState("12m");

  const handleRangeChange = (value: string) => {
    setActiveRange(value);
  };

  return (
    <Card className={styles.container} bordered={false}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <Title level={2} className={styles.title}>
            Amazon Chart
          </Title>
          <div className={styles.badge}>
            <div className={styles.flagIcon}>US</div>
            <Text className={styles.badgeText}>United States</Text>
          </div>
          <div className={styles.badge}>
            <Text className={styles.badgeText}>Consumer Discretionary</Text>
          </div>
          <div className={styles.badge}>
            <Text className={styles.badgeText}>Mega Cap</Text>
          </div>
        </div>

        <div className={styles.tabsContainer}>
          <Segmented
            options={timeRanges}
            value={activeRange}
            onChange={handleRangeChange}
            className={styles.customSegmented}
          />
        </div>
      </div>

      <div className={styles.chartContainer}>
        <div className={styles.chartWrapper}>
          {chartData && chartData.length > 0 ? (
            <ResponsiveContainer width="100%" height={"100%"}>
              <LineChart
                data={chartData}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid stroke="#f5f5f5" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  tick={{
                    fill: "#535862",
                    fontSize: 12,
                    fontFamily: "Inter, sans-serif",
                  }}
                />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{
                    fill: "#535862",
                    fontSize: 12,
                    fontFamily: "Inter, sans-serif",
                  }}
                />
                <Tooltip
                  cursor={{ stroke: "#E9D5FF", strokeWidth: 2 }}
                  contentStyle={{
                    backgroundColor: "#fff",
                    border: "1px solid #eee",
                    borderRadius: 8,
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    fontFamily: "Inter, sans-serif",
                  }}
                />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#8B5CF6"
                  strokeWidth={3}
                  dot={false}
                  activeDot={{ r: 5, stroke: "#8B5CF6", strokeWidth: 2 }}
                />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#999",
                fontSize: "14px",
              }}
            >
              No data available for display
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};
